export const selectWaterIsLoading = state => state.water.isLoading;
export const selectWaterError = state => state.water.error;
export const selectWaterNotes = state => state.water.notes;
